import { render } from "./TButtonWhite.vue?vue&type=template&id=922ee06c"
import script from "./TButtonWhite.vue?vue&type=script&lang=js"
export * from "./TButtonWhite.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__